import { SuccessColors } from '../../../../foundation/colors/successColors/successColors/index.js';
import { AbsolutesWhiteColors } from '../../../../foundation/colors/absolutesWhiteColors/absolutesWhiteColors/index.js';
import { Gradients } from '../../../../foundation/colors/gradients/gradients/index.js';
import { NegativeColors } from '../../../../foundation/colors/negativeColors/negativeColors/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';
import { SecondaryColors } from '../../../../foundation/colors/secondaryColors/secondaryColors/index.js';
import { PositiveColors } from '../../../../foundation/colors/positiveColors/positiveColors/index.js';
import { PremiumColors } from '../../../../foundation/colors/premiumColors/premiumColors/index.js';
import { PrimaryColors } from '../../../../foundation/colors/primaryColors/primaryColors/index.js';

const BadgeSkins = {
    premium: {
        backgroundColor: PremiumColors.base.default,
        color: PremiumColors.text.default,
    },
    verified: {
        backgroundColor: PrimaryColors.base.default,
        color: PrimaryColors.text.default,
    },
    ambassador: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    star: {
        backgroundColor: PositiveColors.base.default,
        color: PrimaryColors.base.default,
    },
    masterContributor: {
        backgroundColor: BackgroundColors.base,
        color: SecondaryColors.base.default,
    },
    masterStoryteller: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    dot: {
        backgroundColor: SecondaryColors.base.default,
    },
    dotPremium: {
        backgroundColor: PremiumColors.base.default,
    },
    new: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    newPremium: {
        backgroundColor: PremiumColors.base.default,
        color: PremiumColors.text.default,
        isRectangle: true,
    },
    try: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    tryPremium: {
        backgroundColor: PremiumColors.base.default,
        color: PremiumColors.text.default,
        isRectangle: true,
    },
    beta: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    aiRectangle: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    aiCircle: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    plus: {
        backgroundColor: Gradients.plus,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    pro: {
        backgroundColor: Gradients.pro,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    like: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    follow: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    replay: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    comment: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    newPost: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    save: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    tag: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    mention: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    remix: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    sticker: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    challenges: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    admin: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    fileShare: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    fileJoined: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    plusCrown: {
        backgroundColor: Gradients.plus,
        color: AbsolutesWhiteColors.base.default,
    },
    proCrown: {
        backgroundColor: Gradients.pro,
        color: AbsolutesWhiteColors.base.default,
    },
    hot: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
    },
    gold: {
        backgroundColor: Gradients.plus,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    plusReverse: {
        backgroundColor: PositiveColors.base.default,
        isRectangle: true,
    },
    proReverse: {
        backgroundColor: PositiveColors.base.default,
        isRectangle: true,
    },
    goldReverse: {
        backgroundColor: PositiveColors.base.default,
        isRectangle: true,
    },
    free: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    aiAvatar: {
        backgroundColor: SecondaryColors.base.default,
        color: SecondaryColors.text.default,
        isRectangle: true,
    },
    proTrial: {
        backgroundColor: BackgroundColors.negativeTransparent,
        color: NegativeColors.text.default,
        isRectangle: true,
    },
    plusTrial: {
        backgroundColor: BackgroundColors.negativeTransparent,
        color: NegativeColors.text.default,
        isRectangle: true,
    },
    crownTrial: {
        backgroundColor: BackgroundColors.negativeTransparent,
        color: NegativeColors.text.default,
    },
    essentials: {
        backgroundColor: Gradients.essentials,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    performance: {
        backgroundColor: Gradients.performance,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    lite: {
        backgroundColor: Gradients.essentials,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    max: {
        backgroundColor: Gradients.performance,
        color: AbsolutesWhiteColors.base.default,
        isRectangle: true,
    },
    live: {
        backgroundColor: SuccessColors.base.default,
        color: SuccessColors.text.default,
        isRectangle: true,
    },
};

export { BadgeSkins };
